import script from "./whGOnceImg3.vue?vue&type=script&setup=true&lang=js"
export * from "./whGOnceImg3.vue?vue&type=script&setup=true&lang=js"

import "./whGOnceImg3.vue?vue&type=style&index=0&id=5efb9b58&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5efb9b58"]])

export default __exports__